<template>
    <div
        class="collapse-section"
        :class="{ 'show-overflow': showOverflow, show }"
        :style="{ height }"
    >
        <div class="inner" ref="inner" :class="{ border, show }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CollapseSection',
        props: {
            show: {
                default: false
            },
            border: {
                default: true
            }
        },
        data() {
            return {
                height: '0px',
                showOverflow: this.show,
                ignoreUpdate: false,
                timeout: null
            };
        },
        methods: {
            async onUpdate(initial = false) {
                if (!this.$refs.inner) return;
                if (this.height === 'auto') {
                    this.height = this.$refs.inner.offsetHeight + 'px';
                    this.ignoreUpdate = true;
                    await this.$timeout();
                    if (!this.$refs.inner) return;
                }
                let height;
                if (this.show) {
                    height = this.$refs.inner.offsetHeight;
                    if (!height && initial) {
                        height = 'auto';
                    } else {
                        height += 'px';
                    }
                } else {
                    height = '0px';
                }
                if (height !== this.height) {
                    this.height = height;
                    this.ignoreUpdate = true;
                }
                if (this.show) {
                    if (!this.showOverflow) {
                        this.timeout = setTimeout(() => {
                            this.showOverflow = true;
                            this.ignoreUpdate = true;
                        }, 500);
                    }
                } else {
                    clearTimeout(this.timeout);
                    if (this.showOverflow) {
                        this.showOverflow = false;
                        this.ignoreUpdate = true;
                    }
                }
            }
        },
        updated() {
            if (this.ignoreUpdate) {
                this.ignoreUpdate = false;
                return;
            }
            this.onUpdate();
        },
        mounted() {
            this.onUpdate(true);
        }
    }
</script>

<style lang="scss" scoped>
    .collapse-section {
        overflow: hidden;
        transition: height 0.5s;

        &.show-overflow {
            overflow: visible;
        }

        .inner.border {
            @include border-radius-small;
            border: 1px solid transparent;
            transition: border-color 0.5s;
            padding: 1em;

            &.show {
                border-color: $color-border;
            }
        }
    }
</style>